import React from 'react';
import { graphql } from 'gatsby';
// import { useTranslation } from 'react-i18next';

import { Typography, Grid, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import Layout from '../components/Layout';
import RichButton from '../components/RichButton';
import HtmlAstRender from '../components/HtmlAstRenderer';
import YearsTicks from '../components/YearsTicks';
import Image from '../components/Image';

import useCorrectLanguage from '../hooks/useCorrectLanguage';

import { homeContentName, homePageConfiguration } from '../config';
import { getContent, getFileName, getLangagePrefix, getStringLangagePrefix, mapMiniLangRegex } from '../helpers/commonHelpers';

const useStyles = makeStyles(theme => {
  const maxWidth = mq => `@media (max-width: ${theme.breakpoints.values[mq]}px)`;

  return {
    regions: {
      margin: theme.spacing(2, 0),
    },
    gradientBackground: {
      background: homePageConfiguration.gradient,
    },
    container: {
      color: theme.palette.primary.contrastText,
    },
    image: {
      maxHeight: homePageConfiguration.imageMaxHeight,
      width: '100%',
    },
    imageTitre: {
      maxHeight: '150px',
      width: '50%',
    },
    yearTicks: {
      [maxWidth('md')]: {
        display: 'none',
      },
    },
    content: {
      [maxWidth('md')]: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
      },
    },
  };
});

const Home = ({
  data: {
    allTxtHtml: { nodes: textNodes },
    allHomeDomain: { nodes: homeDomains },
  },
  pageContext: { language },
}) => {
  const classes = useStyles();
  useCorrectLanguage(language);
  const langagePrefix = getLangagePrefix(language);
  const stringLangagePrefix = getStringLangagePrefix(langagePrefix).toUpperCase();
  const imageFileRegex = new RegExp(mapMiniLangRegex(stringLangagePrefix));
  // const [t] = useTranslation();

  const homeTextFile = getFileName({
    language,
    textType: homeContentName,
    regionCode: null,
    period: null,
  });

  const homeTextContent = getContent(
    textNodes.map(({ name, childHtmlRehype: { htmlAst } }) => ({ name, htmlAst })),
    homeTextFile,
  );

  // Version titre littérale
  /*<Typography variant="h1" color="secondary">
  Climat HD
  </Typography>*/

  const homeDomainsLang = homeDomains.map(item => ({
    ...item,
    // find image in images list that match the file name regex (depending in the current language)
    imageLang: item?.images.find(img => img.split('.')[0]?.match(imageFileRegex)),
  }));

  return (
    <Layout
      maxWidth="sm"
      rootClassName={classes.gradientBackground}
      containerClassName={classes.container}
      isHome
    >
      <Box className={classes.content}>

	<Image filename={`/images/ClimatHD.png`} alternativeText={`Climat HD`} className={classes.imageTitre} />

        {Boolean(homeTextContent) && (
          <HtmlAstRender hast={homeTextContent} align="justify" />
        )}

        <Grid
          className={classes.regions}
          container
          spacing={0}
          direction="row"
          justifyContent="space-around"
          alignItems="center"
        >
          {homeDomainsLang.map(({ name: label, link, imageLang }) => (
            <RichButton
              key={`home-${label}`}
              // label={t(label)}
              to={link}
              rowGrid={4}
              isBox
            >
              <Image filename={`/${imageLang}`} alternativeText={`carte ${label}`} className={classes.image} />
            </RichButton>
          ))}
        </Grid>
        <Box className={classes.yearTicks}>
          <YearsTicks />
        </Box>
      </Box>
    </Layout>
  );
};

export default Home;

export const query = graphql`
  query {
    allTxtHtml(
      filter: {name: {regex: "/accueil/"}}
    ) {
      nodes {
        name
        childHtmlRehype {
          htmlAst
        }
      }
    }
    allHomeDomain {
      nodes {
        images
        link
        name
        code
      }
    }
  }
`;
